// extracted by mini-css-extract-plugin
export default {"basic_button":"basic_button___BItRj","button":"button___yfMmJ","fit":"fit___m2Fbj","full_width":"full_width___VTVoQ","icon_only":"icon_only___Sk5MX"};